import { render, staticRenderFns } from "./CharidyAppPage.vue?vue&type=template&id=ed186996&scoped=true&"
import script from "./CharidyAppPage.vue?vue&type=script&lang=js&"
export * from "./CharidyAppPage.vue?vue&type=script&lang=js&"
import style0 from "./CharidyAppPage.vue?vue&type=style&index=0&id=ed186996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed186996",
  null
  
)

export default component.exports